/**
 * Filter factory to display modules/elements
 * v.1.0
 */

angular
  .module('specsguardApp')
  .factory('filterModuleFactory', filterModuleFactory);

// @ts-ignore
filterModuleFactory.$inject = [];

// @ts-ignore
function filterModuleFactory () {

  const factoryModule: any = {};

  factoryModule.addBasicAreaMarker = (modules, areaId) =>
    modules.map((module) => {
      module.submodules.forEach((submodule) => {
        submodule.elements.forEach((element) => {
          element.hasOwnValue = (element.projectLevel === 5 && element.constructionId === areaId);
        });
      });
      return module;
    });

  factoryModule.filterBasicAreaElements = (modules, include) =>
    modules.map((module) => {
      module.submodules.map((submodule) => {
        if (!include) {
          submodule.elements = submodule.elements.filter((elem) => elem.projectLevel === 5);
        }
        return submodule;
      });
      return module;
    });

  factoryModule.removeEmptySubmodules = (modules) =>
    modules.map((mod) => {
      mod.submodules = mod.submodules.filter((submod) => submod.elements.length > 0);
      return mod;
    });

  factoryModule.createMenuStructure = (requirementTypes, modules) => {
    const menuStructure = [];
    // create main menu structure
    requirementTypes.forEach((requirementType) => {
      menuStructure.push(
        {
          viewtab: requirementType.value,
          displayName: requirementType.displayPlural,
          modules: [],
          subMenuItems: [],
        });

    });

    // create submenu structure
    modules.forEach((module) => {
      menuStructure.forEach((menuItem) => {
        if (module.viewtab === menuItem.viewtab) {
          menuItem.modules.push(module);
          menuItem.subMenuItems.push(
            {
              viewtab: module.name,
              displayName: module.name,
              module: module,
            }
          );
        }
      });
    });

    menuStructure.forEach((menuItem) => {
      if (menuItem.subMenuItems.length === 1) {
        menuItem.subMenuItems = [];
      }
    });

    return menuStructure;
  };

  return factoryModule;
}
